"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appearanceDefaults = exports.buttonFields = exports.appearanceFields = exports.buttonShape = exports.appearanceShape = exports.GradientValueSchema = exports.GradientStopSchema = void 0;
const zod_1 = require("zod");
/**
 * Shared "Appearance" settings fragment (SP5) — reused by every section so each
 * gets consistent, Shopify/Square-class styling: background (solid / gradient /
 * transparent), text colour, vertical padding, and content alignment. All fields
 * are optional/defaulted → additive (existing sections validate unchanged) and a
 * missing appearance renders exactly like today.
 */
exports.GradientStopSchema = zod_1.z.object({ color: zod_1.z.string(), position: zod_1.z.number().min(0).max(100) });
exports.GradientValueSchema = zod_1.z.object({
    angle: zod_1.z.number().int().min(0).max(360).default(135),
    stops: zod_1.z.array(exports.GradientStopSchema).default([]),
});
exports.appearanceShape = {
    bgType: zod_1.z.enum(['none', 'solid', 'gradient']).default('none'),
    bgColor: zod_1.z.string().optional(),
    bgColor2: zod_1.z.string().optional(), // legacy gradient end colour (back-compat)
    gradientAngle: zod_1.z.number().int().min(0).max(360).default(135), // legacy (back-compat)
    bgGradient: exports.GradientValueSchema.optional(), // rich multi-stop gradient
    textColor: zod_1.z.string().optional(),
    paddingY: zod_1.z.enum(['none', 'sm', 'md', 'lg', 'xl']).default('md'),
    align: zod_1.z.enum(['left', 'center', 'right']).default('left'),
};
/** Button styling fragment — for sections that render a CTA. */
exports.buttonShape = {
    buttonColor: zod_1.z.string().optional(),
    buttonTextColor: zod_1.z.string().optional(),
    buttonStyle: zod_1.z.enum(['solid', 'outline']).default('solid'),
};
/** Inspector field descriptors for the appearance fragment (grouped under "Appearance"). */
exports.appearanceFields = [
    { name: 'bgType', label: 'Background', control: 'select', group: 'Appearance', options: [
            { label: 'None', value: 'none' }, { label: 'Solid colour', value: 'solid' }, { label: 'Gradient', value: 'gradient' },
        ] },
    { name: 'bgColor', label: 'Background colour', control: 'color', group: 'Appearance', showWhen: { field: 'bgType', equals: 'solid' } },
    { name: 'bgGradient', label: 'Gradient', control: 'gradient', group: 'Appearance', showWhen: { field: 'bgType', equals: 'gradient' } },
    { name: 'textColor', label: 'Text colour', control: 'color', group: 'Appearance' },
    { name: 'paddingY', label: 'Vertical spacing', control: 'select', group: 'Appearance', options: [
            { label: 'None', value: 'none' }, { label: 'Small', value: 'sm' }, { label: 'Medium', value: 'md' },
            { label: 'Large', value: 'lg' }, { label: 'Extra large', value: 'xl' },
        ] },
    { name: 'align', label: 'Content alignment', control: 'select', group: 'Appearance', options: [
            { label: 'Left', value: 'left' }, { label: 'Center', value: 'center' }, { label: 'Right', value: 'right' },
        ] },
];
/** Button field descriptors (grouped under "Button"). */
exports.buttonFields = [
    { name: 'buttonColor', label: 'Button colour', control: 'color', group: 'Button' },
    { name: 'buttonTextColor', label: 'Button text colour', control: 'color', group: 'Button' },
    { name: 'buttonStyle', label: 'Button style', control: 'select', group: 'Button', options: [
            { label: 'Solid', value: 'solid' }, { label: 'Outline', value: 'outline' },
        ] },
];
/** Default appearance values to merge into a manifest's defaults(). */
const appearanceDefaults = () => ({ bgType: 'none', gradientAngle: 135, paddingY: 'md', align: 'left' });
exports.appearanceDefaults = appearanceDefaults;
//# sourceMappingURL=_appearance.js.map